import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	gap: 16px;
	max-height: 500px;
	height: fit-content;
	cursor: pointer;

	p {
		cursor: pointer;
	}
`;

export const ActivitiesContainer = styled.div`
	overflow-y: auto;
	padding-right: 6px;
	display: grid;
	gap: 16px;
	max-height: 464px;

	::-webkit-scrollbar {
		width: 4px;
	}

	::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	::-webkit-scrollbar-thumb {
		background: #888;
	}

	::-webkit-scrollbar-thumb:hover {
		background: #555;
	}
`;

export const OptionSelector = styled.div<{
	$error?: boolean;
	$checked?: boolean;
}>`
	display: grid;
	grid-template-columns: 1fr 32px;
	align-items: center;
	padding: 14px 16px;
	gap: 16px;
	border-radius: 6px;
	border: 2px solid
		${({ $error }) => ($error ? tokens.color_toast_error : 'inherit')};
	background-color: ${({ $checked }) =>
		$checked ? tokens.color_white : tokens.color_gray_light};

	&:hover {
		& > svg {
			transition: transform 0.2s ease;
			transform: translateX(5px);
		}
	}
`;
